<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "SkupSuorganizatorBase"
}
</script>

<style scoped>

</style>
